import {
  WSGrid,
  WSList,
  WSPage,
  WSPageToolbar,
  WSPanel
} from "@wingspanhq/fe-component-library";
import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { MyResourcesTab } from "../types";
import {
  getPathnameMyResourcesTab,
  PARAMETER_MY_RESOURCE_ID,
  PARAMETER_TAB,
  PATH_MY_RESOURCES,
  useGoToMyResourceDetails
} from "../paths";
import { DataViewGrid } from "../../../shared/components/DataView";
import { queriesInsuranceCoverages } from "../../../v3/query/queriesInsuranceCoverages";
import { WSQueries } from "../../../query/WSQuery";
import { selectorInsuranceCoverageStatusPillByExpirationDate } from "../selectors/selectorInsuranceCoverageStatusPillByExpirationDate";
import { useQueryPlanEnrollment } from "../../../query/benefits/useQueryPlanEnrollment";
import { selectorPlanNameByPlanType } from "../selectors/selectorPlanNameByPlanType";
import { MyResourceInsuranceHistory } from "../components/MyResourceInsuranceHistory";
import { selectorInsuranceCoverageStatusDescriptionByInsurance } from "../selectors/selectorInsuranceCoverageStatusDescriptionByInsurance";
import { useGetNow } from "../../../shared/hooks/useGetNow";

type Props = RouteComponentProps<{
  [PARAMETER_TAB]?: MyResourcesTab;
  [PARAMETER_MY_RESOURCE_ID]: string;
}>;

export const RouteMyResourceHistory: React.FC<Props> = ({ match, history }) => {
  const myResourceId = match.params.myResourceId;
  const goToMyResourceDetails = useGoToMyResourceDetails();
  const qInsuranceOverage =
    queriesInsuranceCoverages.getInsuranceCoverage.useQuery({
      coverageId: match.params.myResourceId
    });
  const qPlanEnrollment = useQueryPlanEnrollment(
    qInsuranceOverage.data?.sourceId!,
    {
      enabled: !!qInsuranceOverage.data?.sourceId
    }
  );

  const now = useGetNow();

  return (
    <WSPage colorBackground="gray50">
      <WSQueries queries={{ qInsuranceOverage, qPlanEnrollment }}>
        {({ qInsuranceOverageData, qPlanEnrollmentData }) => {
          const name = selectorPlanNameByPlanType(qPlanEnrollmentData.planType);
          return (
            <>
              <WSPageToolbar
                title="Policy history"
                breadcrumbs={[
                  {
                    label: "My resources",
                    onClick: () => {
                      if (match.params.tab) {
                        return history.push(
                          getPathnameMyResourcesTab(match.params.tab)
                        );
                      } else {
                        history.push(PATH_MY_RESOURCES);
                      }
                    }
                  },
                  {
                    label: name,
                    onClick: () => {
                      goToMyResourceDetails(myResourceId);
                    }
                  },
                  {
                    label: "Policy history"
                  }
                ]}
              />
              <WSGrid>
                <WSGrid.Item span={{ s: "12", m: "8" }}>
                  <WSList gap="XL">
                    <WSPanel>
                      <DataViewGrid
                        gridColumns={2}
                        data={[
                          {
                            label: "Policy name",
                            value: name
                          },
                          {
                            label: "Status",
                            pill: selectorInsuranceCoverageStatusPillByExpirationDate(
                              qInsuranceOverageData.expirationDate
                            ),
                            value: null,
                            hideValue: true,
                            secondaryText:
                              selectorInsuranceCoverageStatusDescriptionByInsurance(
                                qInsuranceOverageData,
                                now
                              )
                          }
                        ]}
                      />
                    </WSPanel>
                    <MyResourceInsuranceHistory
                      planType={qPlanEnrollmentData.planType}
                      isCompactView={false}
                      insuranceCoverageId={qInsuranceOverageData.id!}
                    />
                  </WSList>
                </WSGrid.Item>
                <WSGrid.Item span={{ s: "12", m: "4" }}></WSGrid.Item>
              </WSGrid>
            </>
          );
        }}
      </WSQueries>
    </WSPage>
  );
};
